import { useEffect, useState } from 'react'
import { 
  ShoppingBag, 
  FileText, 
  Package, 
  Truck,
  Mail,
  Globe,
  Box,
  TrendingUp,
  DollarSign,
  Users,
  ShoppingCart,
  UserCheck,
  Store,
  Building2
} from 'lucide-react'
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'

const stats = [
  { name: 'Shopify', icon: ShoppingBag, value: '0', change: '+0%', color: 'bg-gray-800' },
  { name: 'Moloni', icon: FileText, value: '0', change: '+0%', color: 'bg-gray-700' },
  { name: 'Batch', icon: Package, value: '0', change: '+0%', color: 'bg-gray-600' },
  { name: 'Affiliatly', icon: UserCheck, value: '0', change: '+0%', color: 'bg-gray-500' },
  { name: 'Loja V.N. Gaia', icon: Store, value: '0', change: '+0%', color: 'bg-gray-800' },
  { name: 'Loja CC Colombo', icon: Building2, value: '0', change: '+0%', color: 'bg-gray-700' },
  { name: 'DPD', icon: Truck, value: '0', change: '+0%', color: 'bg-gray-600' },
  { name: 'CTT', icon: Mail, value: '0', change: '+0%', color: 'bg-gray-500' },
  { name: 'DHL', icon: Globe, value: '0', change: '+0%', color: 'bg-gray-800' },
  { name: 'MRW', icon: Box, value: '0', change: '+0%', color: 'bg-gray-700' },
]

const salesData = [
  { name: 'Jan', value: 4000 },
  { name: 'Fev', value: 3000 },
  { name: 'Mar', value: 2000 },
  { name: 'Abr', value: 2780 },
  { name: 'Mai', value: 1890 },
  { name: 'Jun', value: 2390 },
]

export default function Dashboard() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Simular carregamento de dados
    setTimeout(() => setLoading(false), 1000)
  }, [])

  if (loading) {
    return (
        <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-600 mt-1">Visão geral de todas as integrações</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => {
          const Icon = stat.icon
          return (
            <div key={stat.name} className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600">{stat.name}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-2">{stat.value}</p>
                  <p className="text-sm text-green-600 mt-1">{stat.change}</p>
                </div>
                <div className={`${stat.color} p-3 rounded-lg`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          )
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Vendas (Últimos 6 meses)</h2>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={salesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="value" stroke="#000000" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Encomendas por Transportadora</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={[
              { name: 'DPD', value: 45 },
              { name: 'CTT', value: 32 },
              { name: 'DHL', value: 28 },
              { name: 'MRW', value: 15 },
            ]}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#000000" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Resumo Rápido</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="p-3 bg-gray-100 rounded-lg">
              <DollarSign className="w-6 h-6 text-black" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Receita Total</p>
              <p className="text-xl font-bold text-gray-900">€0,00</p>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="p-3 bg-gray-100 rounded-lg">
              <ShoppingCart className="w-6 h-6 text-black" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Encomendas</p>
              <p className="text-xl font-bold text-gray-900">0</p>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="p-3 bg-gray-100 rounded-lg">
              <Users className="w-6 h-6 text-black" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Clientes</p>
              <p className="text-xl font-bold text-gray-900">0</p>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="p-3 bg-gray-100 rounded-lg">
              <TrendingUp className="w-6 h-6 text-black" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Crescimento</p>
              <p className="text-xl font-bold text-gray-900">+0%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
